export default "__VITE_ASSET__ee08c22e__"